import React, {useState} from "react";
import clsx from "clsx";
import { Button, Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem, Container, Link, IconButton, useTheme, Drawer, AppBar, Toolbar, CssBaseline, Typography, Divider, Grid} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Disturbance from "../images/Disturbance.png";
import Project3_TechnicalSummary from "../images/Project3_TechnicalSummary.pdf";
import Image from "material-ui-image";

//Icons
import AssessmentIcon from "@material-ui/icons/Assessment";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MenuIcon from "@material-ui/icons/Menu";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import PublicIcon from "@material-ui/icons/Public";
import InfoIcon from "@material-ui/icons/Info";

//Components
import Map3 from "../components/Map3Components/Map3";
import Map3Plots from "../components/Map3Components/Map3Plots"
import MapModal from "../components/MapModal";
import CopyUrlBtn from "../components/CopyUrlBtn";
import Logo from "../components/Logo";
import IntroModal from "../components/IntroModal";

const drawerWidth = 550;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // minHeight: "7.1vh",
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  toolbar: {
    minHeight: "48px"
  },
  title: {
    flexGrow: 1,
    fontSize: "23px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    minHeight: "92.9vh",
    //1920 and up
    [theme.breakpoints.up("xl")]: {
      minHeight: "99vh",
    },
    // 1920px and down
    [theme.breakpoints.down("xl")]: {
      minHeight: "99vh",
    },
    // 1280px and down
    [theme.breakpoints.down("lg")]: {
      minHeight: "92.9vh",
    },
    // 960px and down
    [theme.breakpoints.down("md")]: {
      minHeight: "92.9vh",
    },
    // 600px and down
    [theme.breakpoints.down("sm")]: {
      minHeight: "92.9vh",
    },
    // 0px
    [theme.breakpoints.down("xs")]: {
      minHeight: "93.8vh",
    },
    
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#CED8D7",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  beta: {
    color: "#DEF000",
    align: "left",
  },
  assessmentIcon: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

export default function PersistentDrawerRight() {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [graphData, setGraphData] = useState(null);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen2((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen2(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen2(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open2);
  React.useEffect(() => {
    if (prevOpen.current === true && open2 === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open2;
  }, [open2]);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <div>
            <Button
              ref={anchorRef}
              aria-controls={open2 ? "menu-list-grow" : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              color="inherit"
              edge="start"
              className={classes.menuButton}
              aria-label="open drawer"
            >
              <MenuIcon />
            </Button>
            <Popper
              open={open2}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper
                    style={{
                      border: "7px solid #CED8D7",
                    }}
                  >
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList
                        autoFocusItem={open}
                        id="menu-list-grow"
                        onKeyDown={handleListKeyDown}
                      >
                        <MenuItem onClick={handleClose}>
                          <Link color="inherit" href="/">
                            <ExitToAppIcon
                              style={{ color: "rgb(246, 122, 55)" }}
                            />
                            &nbsp; Connectivity on Agricultural Lands
                          </Link>
                        </MenuItem>
                        <MenuItem onClick={handleClose}>
                          <Link color="inherit" href="/project2">
                            <ExitToAppIcon
                              style={{ color: "rgb(246, 122, 55)" }}
                            />
                            &nbsp; Anthropogenic Impacts
                          </Link>
                        </MenuItem>
                        <MenuItem onClick={handleClose} disabled>
                          <Link color="inherit" href="/project2">
                            <ExitToAppIcon
                              style={{ color: "rgb(246, 122, 55)" }}
                            />
                            &nbsp; Monitoring Forest Change
                          </Link>
                        </MenuItem>
                        <MenuItem onClick={handleClose}>
                          <Link
                            color="inherit"
                            href="https://analytics-lab.org/ecosystemmonitoring/"
                          >
                            <PublicIcon
                              style={{ color: "rgb(246, 122, 55)" }}
                            />
                            &nbsp; Analytics Lab + AI for Earth
                          </Link>
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>

          <div style={{marginLeft: "15px"}} >
          <CopyUrlBtn />
          </div>

          <MapModal
            align="center"
            ModalTitle={"About This Map"}
            ModalBody={
              <>
                <p style={{ fontSize: "1rem" }}>
                  Forest structure is a vital metric in ecological studies for
                  delineating habitat location, condition, vulnerability, and
                  connectivity for numerous species and biological processes of
                  concern. This app provides a continually updating platform to
                  monitor and understand how forest disturbances such as fire,
                  insects, disease, and human land use are changing our natural
                  environment. The beta version of this app is displaying data
                  only for portions of California and Nevada, with
                  national-level data forthcoming.
                </p>
                <p style={{ fontSize: "1rem" }}>
                  This map utilizes a state-of-the-art multi-task recurrent
                  convolutional neural network to integrate multiple data types
                  from various Earth observation sensors to estimate forest
                  structure metrics. The development and deployment of this AI
                  model was made possible with support from Microsoft AI for
                  Earth using Azure Blob Storage, Azure Open Datasets, AzureML,
                  Azure Kubernetes Service and Azure Compute Virtual Machines.
                </p>
                <p style={{ fontSize: "1rem" }}>
                  Download the technical summary and methods
                  <a
                    href={Project3_TechnicalSummary}
                    download="Monitoring_Forest_Change_at_Scale"
                  >
                    {" "}
                    here.
                  </a>
                </p>
                <Image src={Disturbance} cover={true} disableTransition style={{padding: "45px"}}/>

              </>
            }
            style={{ paddingRight: "3px" }}
          ></MapModal>

          <Typography variant="h6" align="center" className={classes.title}>
            Monitoring U.S. Forest Change at Scale with AI
          </Typography>

          {/* <Typography variant="h6" noWrap className={classes.beta}>
            BETA
          </Typography> */}

          <IntroModal
          align="center"
          ModalTitle={"Welcome"}
          ModalBody={
            <>
              <p style={{ fontSize: "1rem" }}>
              Welcome to the forest structural change map. This map displays outputs from CSP Analytics Lab’s latest AI model utilizing remotely sensed data served on Microsoft Planetary Computer to estimate annual forest structure metrics. By mapping the components of forest structure over time, we can observe the changes in forest canopy cover percentage, forested biomass, and basal area (forest tree density). Monitoring changes in these metrics by disturbance areas such as wildfire can allow forest managers to understand what was lost and how long it takes for a region to recover. All forest metrics are estimated within a 30m x 30m pixel area.
              </p>
              </>
              }
          >

          </IntroModal>

          

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerOpen}
            className={clsx(open && classes.hide)}
          >
            <AssessmentIcon
              className={classes.assessmentIcon}
              fontSize="large"
            />
          </IconButton>

          <Logo className="smallScreenLogo" height={40} width={100} />
        </Toolbar>
      </AppBar>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div className={classes.drawerHeader} />
          <Map3 graphData={graphData} setGraphData={setGraphData} setOpen={setOpen}/>
      </main>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={open}
        classes={{
          paper: classes.drawerPaper,
          backgroundColor: "#ced8d7",
        }}
      >
        <div
          className={classes.drawerHeader}
          style={{ backgroundColor: "#ffffff" }}
        >
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <>
                <ChevronRightIcon />
              </>
            )}
          </IconButton>
          <Container style={{ backgroundColor: "#ffffff" }}>
            <Typography align="center" variant="h5">
              Graphs
            </Typography>
          </Container>
        </div>
        <Divider />
        {/* <div style={{ textAlign: "center" }}>
          <br></br> <br></br> <br></br>
          <h6>
            Data is currently being analyzed, plots and graphs coming soon!
          </h6>
        </div> */}
          <Map3Plots graphData={graphData}/>

      </Drawer>
    </div>
  );
}